import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import { ReactComponent as HomeLineIcon } from "../assets/imgs/icons/home-line.svg"

export const menuItems = [
  {
    label: "Home",
    href: "/home",
    icon: <HomeLineIcon sx={{ mr: 1 }} />,
  },
  {
    label: "List Your Venue",
    href: "/list-your-venue",
    icon: <AddCircleOutlineIcon sx={{ position: "relative", right: 5 }} />,
  },
  {
    label: "Partner Sign in",
    href: "/login?role=partner",
  },
]
